import { createFileRoute } from '@tanstack/react-router'

import Order from 'pages/Order'

export const Route = createFileRoute('/_auth/_global/orders/$id')({
  component: Order,
})
